import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { IHocSinhAce } from '../../../models/response/hoc-sinh/IHocSinhAce';
import { eHocSinhAceActionTypeIds, IHocSinhAceActionTypes } from '../../action-types/hoc-sinh/IHocSinhAceActionTypes';


export function* hocSinhAceSaga(): any {
    yield takeLatest(eHocSinhAceActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eHocSinhAceActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eHocSinhAceActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.hocSinhAce.select_all)
    if (res.is_success) {
        yield put(actions.hocSinhAce.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.hocSinhAce.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IHocSinhAceActionTypes): any {
    const payload: IHocSinhAce = action.payload as IHocSinhAce;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.hocSinhAce.update, payload)
    } else {
        res = yield call(apiWrapper.hocSinhAce.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.hocSinhAce.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.hocSinhAce.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IHocSinhAceActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.hocSinhAce.delete, payload)
    if (res.is_success) {
        yield put(actions.hocSinhAce.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.hocSinhAce.DELETE_ERROR(res.message ?? "Error"))
    }
}
